import './mobile-container.css';
import {TabContentMobile} from "./tab-content-mobile";
export const MobileContainer = {
    props: {
        is_active: {
            type: Boolean,
            required: true,
        },
        is_mobile: {
            type: Boolean,
            required: true,
        },
        departure: {
            type: Object,
            required: true,
        },
        arrival: {
            type: Object,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        schedule: {
            today: {
                date: '',
                trips: [],
            },
            tomorrow: {
                date: '',
                trips: [],
            },
        }
    },
    components: {
        TabContentMobile
    },
    data(): object
    {
        return {
            current_tab: 'today'
        }
    },
    computed: {
        tripsTodayCount()
        {
            return this.getNameTrips(this.schedule.today.trips.length);
        },
        tripsTomorrowCount()
        {
            return this.getNameTrips(this.schedule.tomorrow.trips.length);
        },
    },
    methods: {
        getNameTrips(trip_count)
        {
            let return_text = '';
            if (typeof trip_count !== 'number') {
                trip_count = 0;
            }


            const reg = new RegExp(`^(.*)(\\d)$`, `gmi`);
            let trip_count_txt = '' + trip_count;


            let matches = reg.exec(trip_count_txt);

            
            switch (parseInt(matches[2])) {
                case 1:
                    return_text = trip_count + ' рейс';
                    break;
                case 2:
                case 3:
                case 4:
                    return_text = trip_count + ' рейса';
                    break;
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 0:
                    return_text = trip_count + ' рейсов';
                    break;
            }
            return return_text;
        },
    },
    template: `
        <div class="buy-ticket__result search-result-moblie" v-if="is_active === true && is_mobile === true">
            <div class="search-result-moblie__notes">
                <span>Время отправления и прибытия местное</span>
            </div>
            <div class="search-result-moblie__content">
                <TabContentMobile
                    v-for="(trip_day, trip_day_key) in schedule" :key="trip_day_key"
                    :is_active="trip_day_key === current_tab"
                    :trip="trip_day.trips"
                    :current_day="current_tab"
                />
            </div>
        </div>`,
}